import { render, staticRenderFns } from "./nodes-settings.vue?vue&type=template&id=84d8eb78"
import script from "./nodes-settings.vue?vue&type=script&lang=js"
export * from "./nodes-settings.vue?vue&type=script&lang=js"
import style0 from "./nodes-settings.vue?vue&type=style&index=0&id=84d8eb78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports